export const ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.dispatcher.dis.mobile'
export const IOS_APP_LINK = 'https://apps.apple.com/us/app/dispatcher/id1539045274'
